export default class SiteInformation {
    constructor(_id, _Street1, _Street2, _State, _City, _Zip, _Country, _Owner, _LotStructure, _CouncilDistrict, _CensusTract, _AcqMethod, _OtherAcqMethod, _DORNumber, _OPANumber, _Candidates, _RawAddress) {
      this.id = _id;
      this.Street1 = _Street1;
      this.Street2 = _Street2;
      this.State = "Pennsylvania";
      this.City = "Philadelphia";
      this.Zip = _Zip;
      this.Country = "United States";
      this.Owner = _Owner;
      this.LotStructure = _LotStructure;
      this.CouncilDistrict = _CouncilDistrict;
      this.CensusTract = _CensusTract;
      this.AcqMethod = _AcqMethod;
      this.OtherAcqMethod = _OtherAcqMethod;
      this.DORNumber = _DORNumber;
      this.OPANumber = _OPANumber;
      this.Candidates = _Candidates;
      this.RawAddress = _RawAddress;
    }
  }